import { DateString, FloatString, Nullable } from '../types';
import { ChargingNetworks, TChargingNetworkId } from './ChargingNetwork';
import { ChargingType, TChargingTypeId } from './ChargingType';
import { TEquipmentCategoryId } from './EquipmentCategory';
import { EquipmentUseCase, TEquipmentUseCaseId } from './EquipmentUseCase';
import { ForkliftClassification, TForkliftClassificationId } from './ForkliftClassification';
import { RetirementReason, TRetirementReasonId } from './RetirementReason';
import {
  Client,
  EquipmentType,
  EquipmentUsage,
  FSERegistrationStatus,
  Facility,
  Program,
  TClientId,
  TEquipmentTypeId,
  TFSERegistrationStatusId,
  TFacilityId,
  TProgramId,
  TReportingPeriodTypeId,
  TUserId,
  User,
} from '/src/lib/models';

export type TEquipmentId = number;

export interface Equipment {
  charging_network_id: TChargingNetworkId;
  charing_network: ChargingNetworks;
  current_reporting_period: DateString;
  forklift_classification_id: TForkliftClassificationId;
  forklift_classification: ForkliftClassification;
  equipment_use_case_id: TEquipmentUseCaseId;
  equipment_use_case: EquipmentUseCase;
  equipment_category_id?: TEquipmentCategoryId;
  charging_type_id: TChargingTypeId;
  charging_type: ChargingType;
  charging_level: string;
  charging_usage_type: string;
  client_id: TClientId;
  client?: Client;
  comments: Nullable<string>;
  connector_type: string;
  duplicate_of_equipment: Nullable<string>;
  equipment_type_id: TEquipmentTypeId;
  equipment_type: EquipmentType;
  equipment_usages: EquipmentUsage[];
  current_reporting_period_equipment_usage: Nullable<EquipmentUsage>;
  facility_id: TFacilityId;
  facility?: Facility;
  first_active_reporting_quarter: DateString;
  first_day_in_service: Nullable<DateString>;
  fse_id: Nullable<string>;
  fse_registration_status_id: TFSERegistrationStatusId;
  fse_registration_status: FSERegistrationStatus;
  fse_ru: Nullable<string>;
  id: TEquipmentId;
  is_active: boolean;
  is_finalized: boolean;
  is_metered: boolean;
  last_active_reporting_quarter: Nullable<DateString>;
  retirement_reason_id: Nullable<TRetirementReasonId>;
  retirement_reason: Nullable<RetirementReason>;
  retirement_reason_other: Nullable<string>;
  latitude: FloatString;
  longitude: FloatString;
  manufacturer: string;
  model_number: Nullable<string>;
  model_year: number;
  name: Nullable<string>;
  nameplate_rating_kw: Nullable<number>;
  program_id: TProgramId;
  program?: Program;
  rated_capacity: string;
  reporting_period_type_id?: TReportingPeriodTypeId;
  serial_number: string;
  unit_number: Nullable<string>;
  used_for_charging: string;
  created_at?: DateString;
  created_by_user_id: TUserId;
  created_by_user?: User;
}
